import { Reducer as Reducer_ } from 'redux';
import {
  IEvaluatedQDModelsActionType as IEvaluatedQDModelsActionType_,
  ILoadApplicationHistoryActionType as ILoadApplicationHistoryActionType_,
  IActiveQDModelsActionType as IActiveQDModelsActionType_
} from '../actions/loan-application-actions';
import LoanApplicationHistory_ from '../../data/models/LoanApplicationHistory';
import QDApplicationModel_ from '../../data/models/QDApplicationModel';
import * as types from '../actions/actionTypes/loan-applications';
import ResponseBase_ from '../../data/models/ResponseBase';

/* eslint-disable max-len */
const loanApplicationReducer: Reducer_<ResponseBase_<QDApplicationModel_[]>, IActiveQDModelsActionType_> = (state = { errorCode: 0, message: '', result: [], }, { type, payload, }) => {
  switch (type) {
    case types.GET_ACTIVE_QD_MODELS_SUCCESS:
      return { ...payload, };

    default:
      return state;
  }
};

/* eslint-disable max-len */
const evaluateQDModelsReducer: Reducer_<ResponseBase_<QDApplicationModel_[]>, IEvaluatedQDModelsActionType_> = (state = { errorCode: 0, message: '', result: [], }, { type, payload, }) => {
  switch (type) {
    case types.GET_EVALUATED_QD_MODELS_SUCCESS:
      return { ...payload, };
    default:
      return state;
  }
};

const loanApplicationHistoryReducer: Reducer_<LoanApplicationHistory_[], ILoadApplicationHistoryActionType_> = (state = [], { type, payload, }) => {
  switch (type) {
    case types.GET_LOAN_APPLICATION_HISTORY_SUCCESS:
      return [...payload];

    default:
      return state;
  }
};

export { loanApplicationReducer, loanApplicationHistoryReducer, evaluateQDModelsReducer };
